import { useMemo } from 'react';

import { useGetSensorsDataByEventAndIds } from '@realTimeDataAccess';
import { CameraChanged, CameraInfo, ISiteControlDeviceChanged } from '@scaleaq/sitecontrol-lib';

const CAMERA_CHANGED_EVENT_NAME = new CameraChanged().className;

/**
 * Latest live `CameraInfo` for one camera, taken from its `CameraChanged` SignalR messages.
 * `undefined` until the first message arrives, so callers fall back to the REST camera.
 *
 * Every message updates this hook's own state, so the calling component re-renders at message
 * rate. Call it from small leaf components only, never from the widget root.
 */
export const useCameraChanged = (cameraId: string | undefined): CameraInfo | undefined => {
  const id = cameraId ?? '';
  const ids = useMemo(() => [id], [id]);
  const { results } = useGetSensorsDataByEventAndIds<ISiteControlDeviceChanged<CameraInfo>>(
    ids,
    CAMERA_CHANGED_EVENT_NAME
  );

  return results[id]?.deviceInfo;
};
